import classnames from 'classnames';
import styles from './style.module.css';
import { Container } from '../../components/Container/index';
import logo from '../Logo/zinier-logo-with-name-black.svg';
import svg from './Alert.svg';
import { getLocalString } from '../../languages/index';
import { useLocation } from 'react-router-dom';

const ErrorPage = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const code = urlParams.get('code') || '';
  const message = urlParams.get('message') || '';

  const handleRedirectToLogin = () => {
    window.location.href = 'https://' + window.location.host + '/';
  };

  return (
    <Container className={styles.container}>
      <div className={classnames(styles.contentContiner, 'row')}>
        <img src={logo} alt={'zinier'} onClick={handleRedirectToLogin} />
        <div className={classnames(styles.subContiner)}>
          <div>
            <img src={svg} alt='Alert' />
          </div>
          <p className={styles.errorHeader}>
            {getLocalString('Oops', 'Oops!')} {code && 'ERROR ' + code}
          </p>
          <div className={styles.descContiner}>
            <span>{message}</span>
          </div>
          <div className={classnames(styles.footer)}>
            <span>{getLocalString('copyright')} 2014 - </span>
            <span>{new Date().getFullYear()}</span>
            <span> Zinier Inc.</span>
            <p>{getLocalString('pf_rights_reserved')}</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ErrorPage;
